import { countries } from '../../assets/countryList'
import SearchableSelect from './Forms/SearchableSelect'

type JurisdictionSelectProps = {
    value: string,
    onChange: (value: string) => void;
}

const options = [
    { value: '', label: 'Any' },
    ...countries.map((country) => ({ value: country['alpha-3'], label: country['label'] })),
]

function JurisdictionSelect({value, onChange}: JurisdictionSelectProps) {
    return (
        <SearchableSelect
            options={options}
            value={options.find((option) => option.value === value) ?? options[0]}
            onChange={(option) => onChange(option?.value ?? '')}
        />
    )
}

export default JurisdictionSelect;
